/**
 * OBD-II PID definitions and parsing utilities for MSV80/N51
 */

export function hexToBytes(hex) {
  const clean = hex.replace(/[\s\r\n>]/g, '');
  const bytes = [];
  for (let i = 0; i < clean.length; i += 2) {
    const byte = parseInt(clean.substr(i, 2), 16);
    if (!isNaN(byte)) bytes.push(byte);
  }
  return bytes;
}

export const OBD_PIDS = {
  RPM: { pid: '010C', name: 'Engine RPM', unit: 'RPM', parse: (hex) => {
    const bytes = hexToBytes(hex);
    return bytes.length >= 2 ? ((bytes[0] * 256) + bytes[1]) / 4 : null;
  }},
  SPEED: { pid: '010D', name: 'Vehicle Speed', unit: 'MPH', parse: (hex) => {
    const bytes = hexToBytes(hex);
    return bytes.length >= 1 ? bytes[0] * 0.621371 : null;
  }},
  COOLANT_TEMP: { pid: '0105', name: 'Coolant Temp', unit: '°F', parse: (hex) => {
    const bytes = hexToBytes(hex);
    return bytes.length >= 1 ? (bytes[0] - 40) * 9/5 + 32 : null;
  }},
  INTAKE_TEMP: { pid: '010F', name: 'Intake Temp', unit: '°F', parse: (hex) => {
    const bytes = hexToBytes(hex);
    return bytes.length >= 1 ? (bytes[0] - 40) * 9/5 + 32 : null;
  }},
  MAF: { pid: '0110', name: 'MAF Rate', unit: 'g/s', parse: (hex) => {
    const bytes = hexToBytes(hex);
    return bytes.length >= 2 ? ((bytes[0] * 256) + bytes[1]) / 100 : null;
  }},
  THROTTLE: { pid: '0111', name: 'Throttle Position', unit: '%', parse: (hex) => {
    const bytes = hexToBytes(hex);
    return bytes.length >= 1 ? (bytes[0] * 100) / 255 : null;
  }},
  ENGINE_LOAD: { pid: '0104', name: 'Engine Load', unit: '%', parse: (hex) => {
    const bytes = hexToBytes(hex);
    return bytes.length >= 1 ? (bytes[0] * 100) / 255 : null;
  }},
  TIMING_ADV: { pid: '010E', name: 'Timing Advance', unit: '°', parse: (hex) => {
    const bytes = hexToBytes(hex);
    return bytes.length >= 1 ? (bytes[0] / 2) - 64 : null;
  }},
  STFT_B1: { pid: '0106', name: 'STFT B1', unit: '%', parse: (hex) => {
    const bytes = hexToBytes(hex);
    return bytes.length >= 1 ? ((bytes[0] - 128) * 100) / 128 : null;
  }},
  LTFT_B1: { pid: '0107', name: 'LTFT B1', unit: '%', parse: (hex) => {
    const bytes = hexToBytes(hex);
    return bytes.length >= 1 ? ((bytes[0] - 128) * 100) / 128 : null;
  }},
  // O2 Sensor 1 wide-range equivalence ratio (lambda). AFR is reported in the
  // universal gasoline-equivalent scale (lambda × 14.7) — same convention the
  // backend datalog parser uses — so the AI Iterator can read it directly.
  AFR: { pid: '0134', name: 'AFR', unit: 'AFR', parse: (hex) => {
    const bytes = hexToBytes(hex);
    if (bytes.length < 2) return null;
    const lambda = ((bytes[0] * 256) + bytes[1]) * 2 / 65536;
    if (!(lambda > 0.3 && lambda < 2.5)) return null; // reject junk/no-data
    return lambda * 14.7;
  }},
};

export const ACTIVE_PIDS = ['RPM', 'SPEED', 'ENGINE_LOAD', 'THROTTLE', 'AFR', 'COOLANT_TEMP', 'INTAKE_TEMP', 'TIMING_ADV', 'STFT_B1', 'LTFT_B1', 'MAF'];

export const CSV_HEADERS = ['timestamp', 'RPM [RPM]', 'SPEED [MPH]', 'ENGINE_LOAD [%]', 'THROTTLE [%]',
  'AFR', 'COOLANT_TEMP [°F]', 'INTAKE_TEMP [°F]', 'TIMING_ADV [°]',
  'STFT_B1 [%]', 'LTFT_B1 [%]', 'MAF [g/s]'];
